import React, { useState } from 'react'
import { Pane, Text, Checkbox, Table, Tooltip, Textarea } from 'evergreen-ui'
import { Money } from '../Misc';

export function OrderRow(props) {
    const order = props.order;
    const details = props.details;
    const [checked, setChecked] = React.useState(false);
    return (
        <Pane display={"flex"} width={"550px"} flexDirection="row" margin={"10px"} padding={"10px"} border={"1px solid"} borderRadius={"10px"} background={checked ? "#c6ebff" : "#fafbff"}>
            <Pane borderRight={"2px dashed black"} display={"flex"} flex={"1"} justifyContent="center" alignItems="center" position="relative" >
                <Pane display="flex" flexDirection="row" gap={"10px"}>
                    <Pane position="absolute" top={"0"} left="0">
                        <input type="checkbox" onClick={(e) => { setChecked(e.target.checked); props.selectedItems([order, details], e.target.checked) }} style={{ height: "25px", width: "25px" }} />
                    </Pane>
                    {details &&
                        <Pane display="flex" justifyContent="center" alignItems="center">
                            <div className="rowSVG" dangerouslySetInnerHTML={{ __html: details.book.svg }} />
                        </Pane>
                    }
                    {!details &&
                        <Pane width={200} height={200} border={"1px solid"} borderRadius={"10px"} display="flex" justifyContent="center" alignItems="center">
                            <Pane padding={10}>
                                N/A
                            </Pane>

                        </Pane>
                    }
                </Pane>
            </Pane>
            <Pane display={"flex"} flex={"1"} justifyContent="left" alignItems="center">
                <Pane display="flex" flexDirection="column" justifyContent="left" alignItems="left" gap={"20px"} padding={"20px"}>
                    <Text><strong>Qty</strong>: {order.Qty ? order.Qty : "N/A"}</Text>
                    {details && <>
                        <Text height={"25px"}><strong>Filename:</strong> {details.book.display}</Text>
                        <Text><strong>Material:</strong> {details.selMaterial.Mgroup} {details.selMaterial.Mgroup.localeCompare(details.selMaterial.Material) == 0 ? null : "- " + details.selMaterial.Caption}</Text>
                    </>
                    }

                    {!details && <>
                        <Tooltip content={order.Description}><Text height={"40px"} overflowY={"scroll"}><strong>Description:</strong> {order.Description ? order.Description : "N/A"}</Text></Tooltip>
                        <Text><strong>Material:</strong> {order.Material ? order.Material : "N/A"}</Text>
                    </>
                    }

                    <Table width={"200px"} elevation={2} margin={8}>
                        <Table.Head textAlign={"center"} padding={0} height={32}>
                            <Table.TextCell>Bends</Table.TextCell>
                            <Table.TextCell>Painting</Table.TextCell>
                        </Table.Head>
                        <Table.Body textAlign={"center"} padding={0}>
                            <Table.Row height={32}>
                                <Table.TextCell>{order.FoldingQty ? order.FoldingQty : "0"}</Table.TextCell>
                                <Table.TextCell>{order.Color ? order.Color : "None"}</Table.TextCell>
                            </Table.Row>
                        </Table.Body>
                    </Table>

                    <Textarea value={details ? (details.note ? details.note : "No notes found") : order.note ? order.note : "No notes found"} disabled={true} />
                </Pane>
            </Pane>
        </Pane>
    )
}
